export type LatestOnly<A, R> = {
  run: (arg: A) => Promise<R | undefined>
  cancel: () => void
}

export const createLatestOnly = <A, R>(
  call: (arg: A) => Promise<R>
): LatestOnly<A, R> => {
  let latestCallId = 0

  return {
    run: async (arg: A) => {
      latestCallId += 1
      const callId = latestCallId
      const result = await call(arg)
      return callId === latestCallId ? result : undefined
    },
    cancel: () => {
      latestCallId += 1
    },
  }
}
